module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"last_revision":"Last revision {date}","edit_button":"Edit","delete_button":"Remove","close_button":"Close","delete_alert":"Are you sure you want to remove this article?"},"pt-BR":{"last_revision":"Última revisão {date}","edit_button":"Editar","delete_button":"Remover","close_button":"Fechar","delete_alert":"Tem certeza que deseja remover este artigo?"}}')
  delete Component.options._Ctor
}
